import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Grid2,
  Container,
  Typography,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import handleAxiosError from "../../components/ErrorHandler";
import { notifErr, notifOk } from "../../components/Functions";
import {
  TrainingArea,
  trainingAreaInit,
} from "../../model/entity/TrainingArea";
import {
  trainingAreaValidationObjInit,
  validateTrainingArea,
} from "../../model/validation/TrainingAreaValidation";
import { postFetcher } from "../../components/Fetchers";

const NewTrainingArea = () => {
  const navigate = useNavigate();
  const [triedSubmit, setTriedSubmit] = useState(false);
  const [trainingArea, setTrainingArea] =
    useState<TrainingArea>(trainingAreaInit);
  const [trainingAreaErr, setTrainingAreaErr] = useState(
    trainingAreaValidationObjInit
  );

  useEffect(() => {
    if (triedSubmit) setTrainingAreaErr(validateTrainingArea(trainingArea));
  }, [trainingArea, triedSubmit]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTrainingArea({ ...trainingArea, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setTriedSubmit(true);

    const areaErrors = validateTrainingArea(trainingArea);
    setTrainingAreaErr(areaErrors);

    if (Object.values(areaErrors).some((val) => val === false)) return;

    try {
      await postFetcher(
        `${process.env.REACT_APP_API_URL}/training-areas`,
        trainingArea
      );
      notifOk("Sportoviště úspěšně vytvořeno.");
      navigate("/schedule/training-areas");
    } catch (err) {
      notifErr(handleAxiosError(err));
    }
  };

  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pb: "2rem",
      }}
    >
      <Paper elevation={3} sx={{ padding: "1.5rem" }}>
        <Typography variant="h5" sx={{ marginBottom: "1.5rem" }}>
          Nové sportoviště
        </Typography>
        <Grid2 container spacing={3} size={{ xs: 12, md: 6 }}>
          <Grid2 size={{ xs: 12 }}>
            <TextField
              fullWidth
              size="small"
              label="Název"
              required
              name="name"
              value={trainingArea.name}
              error={!trainingAreaErr.name}
              onChange={handleInputChange}
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <TextField
              fullWidth
              size="small"
              label="Zkratkový kód"
              required
              name="code"
              value={trainingArea.code}
              error={!trainingAreaErr.code}
              onChange={handleInputChange}
            />
          </Grid2>

          <Grid2
            container
            size={{ xs: 12 }}
            sx={{ justifyContent: "right", gap: 2, mt: 1 }}
          >
            <Grid2>
              <Button
                className="cancelBtn"
                variant="outlined"
                onClick={() => navigate("/schedule/training-areas")}
              >
                Zrušit
              </Button>
            </Grid2>
            <Grid2>
              <Button
                className="submitBtn"
                variant="outlined"
                onClick={handleSubmit}
              >
                Vytvořit
              </Button>
            </Grid2>
          </Grid2>
        </Grid2>
      </Paper>
    </Container>
  );
};

export default NewTrainingArea;
